import { render, staticRenderFns } from "./DocumentLinksFilter.vue?vue&type=template&id=36de405a"
import script from "./DocumentLinksFilter.vue?vue&type=script&lang=js"
export * from "./DocumentLinksFilter.vue?vue&type=script&lang=js"
import style0 from "./DocumentLinksFilter.vue?vue&type=style&index=0&id=36de405a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports